<template>
    <div class="harmonyPrivacy">
        <h3>隐私政策</h3>
        西藏嗨球网络科技有限公司以下简称“我们”）深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
        <br />请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。
        <br />更新日期：2025年08月25日
        <br />生效日期：2025年08月25日
        <h5>第一部分 定义</h5>
        即嗨体育：指即嗨体育客户端
        <br />即嗨体育运营主体：指即嗨体育互联网信息及软件技术服务提供者，为西藏嗨球网络科技有限公司。
        <br />个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
        <br />个人敏感信息：指包括身份证件号码、手机号码<i>、交易记录、消费记录、余额等虚拟财产信息</i>。
        <br />个人删除信息：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
        <br />设备信息：包括设备型号、操作系统版本、唯一设备标识码（OAID(HarmonyOS)、ODID(HarmonyOS)、AAID）或其他设备标识等信息。
        <br />服务日志信息：您对我们服务的详细使用情况作为服务日志保存的信息，包括浏览、点击查看、搜索查询、<i>支付、交易、</i><i>关注分享信息、</i>发布信息，以及IP地址、浏览器地址、电信运营商、使用语言、访问日期和时间。
        <h5>第二部分 隐私政策</h5>
        本隐私政策将帮助您了解一下内容：
        <br />一、我们如何收集和使用您的信息
        <br />二、我们如何使用cookie和同类技术
        <br />三、我们如何共享、转让、公开披露您的信息
        <br />四、我们如何保护您的信息
        <br />五、您如何访问及控制您的个人信息
        <br />六、我们如何保护未成年的信息
        <br />七、本隐私政策的适用及更新
        <br />八、如何联系我们
        <h5>一、我们如何收集和使用您的个人信息</h5>
        我们会处于以下目的，收集和使用您的信息：
        <br /><em>（一）帮助您成为我们的平台用户</em>
        <br />1.您注册、登录即嗨体育时，我们将根据您的授权获取您的<em>手机号码。</em>
        <!-- <i>你还可以通过<em>“微信登录”</em>方式更快捷地注册并登录。使用第三方微信登录我们会将您的第三方微信账户与您的即嗨体育账户进行绑定。</i> -->
        <em>若您拒绝提供第三方账号下的信息，则您无法选择使用第三方账号的方式注册并登录，我们承诺该类个人信息的第三方账号渠道来源的合法性。</em>
        <br />2.在您实名认证时，需要提供<em>姓名、身份证号</em>以验证您的身份。前述信息属于敏感信息，如果您拒绝提供，可能无法正常使用我们的部分服务。
        <br />您提供的上述信息，将在您使用即嗨体育服务期间持续授权我们使用。在您主动注销账号时，我们根据适用法律法规的要求尽快使其匿名化或删除您的个人信息。
        <i><br /><em>（二）为您提供即嗨号服务</em>
            <br />1.在您申请“即嗨号”等需进行身份认证的功能或服务时，根据中华人民共和国相关法律法规，您可能需要提供您的<em>真实身份信息（真实姓名、身份证照片、电话号码、银行账户等）</em>以完成实名验证。如您不提供这些信息，您将不能申请“即嗨号”的身份权限，但您可以继续使用“即嗨体育”的其他服务。这些信息属于个人敏感信息，我们将采用行业内通行的方式、并尽最大的商业努力来保护您个人敏感信息的安全。如果您不提供这些信息，您将可能无法获得相关服务，但不影响“即嗨体育”其他功能与服务的正常使用。</i>
        <i><br /><em>（三）为您提供图片文字等内容发布<i>和直播服务</i></em>
            <br />1.当您自行发布图片文字等内容<i>以及享受直播服务时</i>，我们会向您请求授权<em>相机、照片、<i>麦克风权限和</i>设备所在位置信息权限（位置属于敏感信息）</em>。在此过程中，您可以自行选择是否向我们提供，您如果拒绝授权提供，将无法使用此附加功能，但不影响您正常使用即嗨体育的其他功能。
            <br />2.当您通过您的设备上传发布本地储存的图片时，或通过使用我们的产品拍照生产的图片时，我们会访问您的<em>储存（含SD卡）权限</em>，如您不同意我们访问您的储存权限，您可在我们向您请求授权时与已拒绝或通过您的设备关闭相应的权限。
            <br /><em>（四）为您提供搜索服务</em>
            <br />您使用“即嗨体育”的搜索服务时，我们会收集您的<em>搜索关键字信息、日志记录等</em>。为了提供高效的搜索服务，<em>部分前述信息会暂时存储在您的本地存储设备之中</em>，并可向您展示搜索结果内容。在您使用搜索功能时，在搜索页面上将展示您剪切板上最近一次的复制信息，以便为您快速提供您所需要的内容
            。<em>请您放心我们仅会对您的剪贴板最近一次复制的的信息进行展示，不会收集您的剪贴板也不会将前述信息上传至我们的服务器。</em>只有当您搜索框中确认填入前述信息并点击搜索后，为了实现搜索功能我们会搜集该信息。</i>
        <i><br /><em>（五）帮助您购买、查询、使用虚拟财产</em>
            <br />当您通过即嗨体育查询、购买虚拟物品（例如"嗨币"）时，我们会收集记录您的充值、交易、余额信息。</i>
        <br /><em>（六）客服及争议处理</em>
        <br />为了让您可以方便地使用我们提供的产品和服务，即时解答您在使用过程中产生的疑问，您可通过意见反馈向我们反馈。在您使用意见反馈过程中，我们将收集您与我们联系时使用的<em>手机号码或您主动填写的其他联系方式、相关截图、及文字描述</em>，这些信息是定位您反馈的服务问题是必须的，如您拒绝提供相关信息，则我们可能无法为您提供客户服务。
        <br /><em>（七）保障产品、服务及用户使用安全</em>
        <br />为帮助我们更好地了解“即嗨体育”及相关服务的运行情况，以便确保运行与提供服务的安全，我们可能记录<em>网络日志信息</em>，以及使用软件及<em>相关服务的频率、崩溃数据、总体安装、使用情况、性能数据</em>等信息。
        <br /><em>（八）为您提供安全保障</em>
        <br />为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别会员账号异常状态，更好地保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或即嗨体育相关协议规则的情况，我们在应用程序中嵌入应用安全SDK收集您的<em>用户信息、设备信息、<i>交易信息、</i>服务日志信息</em>，并可能使用我们关联公司取得您授权或依据法律共享的信息，来综合判断您账号<i>及交易风险</i>、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
        <br /><em>（九）为您提供附加服务</em>
        <br />我们向您提供的以下附加服务中可能会收集和使用您的个人信息。<em>如果您不提供这些信息，不会影响您使用即嗨体育的浏览等基本服务</em>，但您可能无法获得这些附加服务给您带来的用户体验，这些附加服务包括：
        <i><br /><em>1.基于位置信息的附加服务：</em>当您发帖可择定位服务时，我们会向您请求授权<em>设备所在位置信息权限（位置属于敏感信息）</em>。在此过程中，您可以自行选择是否向我们提供，您如果拒绝授权提供，将无法使用此附加功能，但不影响您正常使用即嗨体育的其他功能。
            <br /><em>2.基于相机的附加服务：</em>您可以使用这个附加功能完成拍照的功能。拍摄<em>照片</em>应用于用户发帖、评论等服务。使用时我们会向您请求相机权限，您可以根据需要进行选择。
            <br /><em>3.基于相册的图片访问及上传服务：</em>您可以使用该功能上传您的<em>照片/图片</em>，以实现更换头像、发表帖子/评论或与客服沟通提供证明等功能。使用时我们会向您请求相机/相册权限，您可以根据需要进行选择。</i>
        <i><br /><em>4.基于麦克风的语音技术相关附加服务：</em>您可在开嗨吧时使用该功能，以便嗨吧的用户收听您的语音。为确保语音嗨吧传递的信息的安全性和规范性，我们会收集您的<em>录音内容</em>。该功能使用时我们会向您请求麦克风权限，您可以根据需要进行选择。</i>
        <br /><em>5.基于日历的附加服务：</em>在您开启我们可读取/写入您日历的权限后，我们将收集您的<em>日历信息</em>用于向您提供签到或者领取权益相关记录及提醒。
        <br /><em>6.基于电话状态的附加服务：</em>您需要授权我们读取<em>本机识别码</em>，用于保障您的账号与使用安全。

        <br />您理解并同意上述附加服务可能需要您在您的设备中开启<em>位置信息（地理位置）、摄像头（相机）、相册（图片库）、<i>麦克风（语音）、</i>日历、电话状态的访问权限，已实现这些权限所涉及信息的收集和使用。请注意，您开启任一权限即代表您授权我们可以收集和使用和相关个人信息来为您提供对应服务，一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集和使用。</em>
        <br /><em>（十）其他</em>
        <br />1.若您提供的信息中含有其他用户的个人信息，再向即嗨体育平台提供这些个人之前，您需确保已经取得合法的授权。
        <br />2.若我们将信息用户本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。
        <br />3.征得授权同意的例外
        <br />您充分理解并同意，根据相关法律法规规定，我们在以下情形中收集、使用您的个人信息无需征得您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：
        <br />1）与国家安全、国防安全有关的；
        <br />2）与公共安全、公共卫生、重大公共利益有关的；
        <br />3）与犯罪侦查、起诉、审判和判决执行等有关的；
        <br />4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
        <br />5）所收集的个人信息是您自行向社会公众公开的；
        <br />6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
        <br />7）根据您的要求签订合同所必需的；
        <br />8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
        <br />9）为合法的新闻报道所必需的；
        <br />10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        <br />11）法律法规规定的其他情形。
        <br />请知悉，根据适用的法律，<em>若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善即嗨体育的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。</em>
        <br />如我们停止运营即嗨体育产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。
        <br />在您主动注销账号时，我们将根据适用法律法规的要求尽快使其匿名或删除您的个人信息。
        <h5>二、我们如何使用 Cookie 和同类技术</h5>
        Cookie和同类技术是互联网中的通用常用技术。当您使用“即嗨体育”及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie或匿名标识符，以收集和存储您在访问、使用“即嗨体育”时的相关信息。我们使用Cookie和同类技术主要为了保障产品与服务的安全、高效运转，帮助您获得更轻松的访问体验。
        <br />我们可能会设置认证与保障安全性的cookie或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。
        <br />我们承诺，我们不会将Cookie用于本隐私政策所述目的之外的任何其他用途。
        <h5>三、我们如何共享、转让、公开披露您的信息</h5>
        <em>（一）共享</em>
        <br />我们不会向其他任何公司、组织和个人分享您的个人信息，但以下情况除外：
        <br />1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        <br />2.我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
        <br />3.与授权合作伙伴共享：<em>仅为实现本隐私权政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。</em>例如，我们聘请来提供第三方数据统计和分析服务的公司可能需要采集和访问个人数据以进行数据统计和分析。在这种情况下，这些公司
        必须遵守我们的数据隐私和安全要求。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。
        <br />对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私政策以及其他任何相关的保密和安全措施来处理个人信息。
        <br /><em>（二）转让</em>
        <br />我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        <br />1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        <br />2.在<em>涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</em>
        <br /><em>（三）公开披露</em>
        <br />我们仅会在以下情况下，公开披露您的个人信息：
        <br />1.获得您明确同意后；
        <br />2.基于法律的披露：<em>在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</em>
        <br /><em>（四）第三方插件使用情况</em>
        <br />为保障相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）或类似应用程序实现相关目的。我们会对合作方获取信息的软件工具开发包（SDK）或类似应用程序进行严格的安全评估，以保护您的个人信息安全。以下是我们接入的主要的第三方服务商的信息：
        <i>
            <br /><em>1.个推推送SDK</em>
            <br />使用目的：用于消息推送服务
            <br />数据类型：应用列表信息、位置相关信息、设备平台、设备厂商、设备品牌、设备型号及系统版本、OAID、ODID(HarmonyOS)、AAID、WIFI连接信息、WIFI BSSID、运营商信息、IMEI、MAC、Serial
            Number、IMSI、ICCID、IP地址、SSID、基站信息
            <br />官网链接：<a href="https://www.getui.com/privacy">https://www.getui.com/privacy</a>
        </i>
        <br /><em>2.友盟SDK</em>
        <br />使用目的：用于实现App一键分享，统计分析服务
        <br />数据类型：共享的个人信息类型：IP地址
        、SDK版本、时间戳、应用标识符、应用程序版本、应用分发渠道、独立设备标识符、设备型号、操作系统版本、语言所在地、时区和网络状态、设备信息（IMEI/Mac地址/ODID(HarmonyOS)/AAID/IDFA/OPENUDID/GUID/SIM 卡 IMSI）
        <br />公司名称：友盟同欣（北京）科技有限公司
        <br />官网链接：<a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a>
        <i>
            <br /><em>3.数美SDK</em>
            <br />使用目的：用于风险控制和欺诈识别，进而保护您的账户和交易安全
            <br />设备基本信息：设备品牌、设备制造商、设备型号、设备名称、设备系统类型及版本信息、设备基本配置、设备基本设置、设备环境、传感器信息（磁场、重力、加速度传感器、陀螺仪传感器）
            <br />设备标识信息：IMEI（国际移动设备识别码）、ICCID（集成电路卡识别码）、IMSI（国际移动用户识别码）、MAC地址、蓝牙MAC地址、ODID(HarmonyOS)、AAID、IDFV（应用开发商标识符）、IDFA（广告标示符）、OAID（匿名设备标识符）、设备序列号
            <br />设备网络信息：网络的接入形式、无线路由器标识（BSSID、SSID、MAC）及IP地址、周边WIFI列表、网络运营商信息、网络基站信息、网络连接状态
            <br />设备应用信息：SDK宿主应用包名及版本号、应用列表（仅用于检测设备上是否存在黑产工具等恶意软件）、运行中进程信息（仅获取当前进程名称）
            <br />公司名称：北京数美时代科技有限公司
            <br />官网链接：<a
                href="https://www.ishumei.com/legal/cn/privacy.html">https://www.ishumei.com/legal/cn/privacy.html</a>
        </i>
        <i>
            <br /><em>4.微信Open SDK Harmony</em>
            <br />使用目的：用于微信账号登录服务、帮助用户分享内容至微信客户端
            <br />收集信息类型：OAID、应用基本信息
            <br />公司名称：腾讯科技（深圳）有限公司
            <br />官网链接：<a href="https://open.weixin.qq.com/">https://open.weixin.qq.com/</a>
        </i>
        <i>
            <br /><em>5.openinstall SDK</em>
            <br /> 我们的产品集成了 openinstall SDK，我们需要向 openinstall SDK 共享您的相关个人信息，为了您的信息安全，我们已经与第三方 SDK 服务商签署严格的数据安全保密协议，这些公司会严格遵守我们的数据隐私和安全要求。
            <br />功能：基础服务（携带参数安装，H5渠道统计，应用统计，一键跳转）
            <br />收集方式：调用系统相关接口自动采集
            <br />SDK收集的个人信息类型：设备品牌、设备型号、操作系统版本、IP地址、粘贴板（剪切板）、ODID(HarmonyOS)、AAID、设备序列号（SerialNumber）、设备传感器（传感器数量）、本地存储权限、IMEI、IDFA、OAID、Mac地址
            <br />关于openinstall服务的更多说明，请参考openinstall隐私政策：<a href="https://www.openinstall.io/privacy.html">https://www.openinstall.io/privacy.html</a>
        </i>
        <br /><em>（五）其他接入第三方服务的情形</em>
        <br />例如，为实现本《隐私政策》中声明的目的，我们可能会接入第三方软件工具开发包(SDK)与第三方应用程序编程接口（API）服务，并将我们依照本政策收集的您的某些信息共享给该等第三方服务商。以便提供更好的客户服务和用户体验。
        <br />该等接入第三方服务由相关的第三方负责运营，须受第三方自己的服务条款及信息保护声明（而非本《隐私政策》）约束。
        <br />我们与第三方合作过程中，将遵守法律规定，按照最小必要原则，安全审慎地处理相关数据。
        <br />我们将按照法律法规的规定，对数据处理涉及的第三方进行严格的限制。要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，保障数据安全。
        <br />出于为您提供服务的目的，我们可能委托第三方服务商处理您的个人信息，该等服务商将严格按照我们委托的目的和相关委托处理协议处理个人信息。
        <br />我们将严格保护您的个人信息，不会主动公开披露您的个人信息，亦不会主动向合作伙伴分享可用于识别您个人身份的信息，除非经您单独同意或法律法规另有规定，例如：
        <br />·为订立、履行个人作为一方当事人的合同所必需，或者按照法律制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；
        <br />·为履行法定职责或者法定义务所必需；
        <br />·为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；
        <br />·为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；
        <br />·依照法律规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；
        <br />·法律、行政法规规定的其他情形
        <br />随着我们业务的持续发展，当发生合并、收购、资产转让等交易导致向第三方转移您的个人信息时，我们将通过推送通知、公告等形式告知您相关情形，按照法律法规及不低于本隐私政策所要求的标准继续保护或要求新的管理者继续保护您的个人信息。
        <h5>四、我们如何保护您的信息</h5>
        1.我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受
        SSL 加密保护；我们同时对我们网站提供 https
        安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        <br />2.我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
        <br />3.您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息透露给他人。您应当重视您的个人信息的保护，您如果发现您的个人信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册账户的安全，或者给您造成其他的损失的，您务必在第一时间通知我们，以便采取相应的措施确保您的账户安全，防止损失的发生或者进一步扩大；否则，我们无须承担由此给您造成的任何损失（及扩大的损失）。
        <br />4.我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。
        <br />5.我们谨此特别提醒您，本隐私政策提供的个人信息保护措施仅适用于您通过即嗨体育应用程序、即嗨体育网页、供第三方网站和应用程序使用的即嗨体育软件开发工具包（SDK）和应用程序编程接口（API）方式来访问和使用我们的产品和服务。一旦您离开“即嗨体育”及相关服务，浏览或使用其他网站、服务及内容资源，我们便没有能力及义务保护您在“即嗨体育”及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于“即嗨体育”的链接或引导。
        <br />6.我们会采取合适的安全措施和技术手段存储及保护您的个人信息，以防止丢失、被误用、受到未授权访问或泄露、被篡改或毁坏。您的个人信息采取了保密措施并将存放在有密码控制的位于中国境内的服务器中，访问均是受限制的。
        <h5>五、您如何访问及控制您的个人信息</h5>
        按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
        <br /><em>（一）访问您的个人信息</em>
        <br />您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
        <br />账户信息——如果您希望访问或编辑您的账户中的个人资料信息、更改您的密码或绑定手机等，您可以通过点击【我】-【个人信息】执行此类操作。
        <br />对于您在使用我们的产品或服务过程中产生的其他个人信息，只要我们不需要过多投入，我们会向您提供。如果您想行使数据访问权，请与客服联系。我们将在十天内回复您的访问请求。
        <br /><em>（二）更正您的个人信息</em>
        <br />当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过“（一）访问您的个人信息”中罗列的方式提出更正申请。如果您无法更正，请与客服联系。我们将在十天内回复您的更正请求。
        <br /><em>（三）删除您的个人信息</em>
        <br />在以下情形中，您可以向我们提出删除个人信息的请求：
        <br />1.如果我们处理个人信息的行为违反法律法规；
        <br />2.如果我们收集、使用您的个人信息，却未征得您的同意；
        <br />3.如果我们处理个人信息的行为违反了与您的约定；
        <br />4.如果我们不再为您提供产品或服务。
        <br /><em>若我们决定响应您的删除请求，我们还将同时通知从我们这里获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</em>
        <br /><em>当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。</em>
        <i>
            <br /><em>（四）注销您的账号</em>
            <br />您可以在我们的产品或服务中直接申请注销账户。<em>产品中申请注销账号路径为“我的-系统设置-账号与安全-注销账号”。您注销账户后，您该账户内所有信息将被清空，我们将停止为您提供服务，并且不会再收集、使用或共享与该账户相关的个人信息，但之前的信息我们热需按照监管要求的时间进行保存，且在依法保存的时间内有关机关有权依法查询。</em>
        </i>
        <br /><em>（五）约束信息系统自动决策</em>
        <br />在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。
        <br /><em>（六）响应您的上述请求</em>
        <br />为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
        <br />我们将在十天内做出答复。如您不满意，还可以通过客服投诉：
        <br />对于您的合理请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
        <br />在以下情形中，按照法律法规要求，我们将无法响应您的请求：
        <br />1.与国家安全、国防安全有关的；
        <br />2.与公共安全、公共卫生、重大公共利益有关的；
        <br />3.与犯罪侦查、起诉和审判等有关的；
        <br />4.有充分证据表明您存在主观恶意或滥用权利的；
        <br />5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
        <h5>六、我们可能向您发送的信息</h5>
        <br />信息推送
        <br />您在使用我们的服务时，我们可能使用您的信息向您的设备发送新闻或推送通知。如您不希望收到这些信息，可在设备上选择取消相关权限或关闭相关提示。
        <h5>七、对第三方的责任声明</h5>
        <br />请您注意，我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：您利用"分享"键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的设备装置
        cookies，从而正常运行上述功能；
        <br />我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《用户协议》或本政策）约束，您需要仔细阅读其条款。本政策仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。
        <h5>八、我们如何保护未成年的信息</h5>
        我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。
        <br />对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
        <br />尽管当地法律和习俗对儿童的定义不同，但我们将不满 14 周岁的任何人均视为儿童。 如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
        <h5>九、本隐私政策的适用及更新</h5>
        我们根据法律可能会适时对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在我们网站上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表了您已充分阅读、理解并接受修改后的隐私权政策并受其约束。
        <h5>十、如何联系我们</h5>
        如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们客服联系：
        <br />微信号：18311337415 手机号：18311337415
        <br />一般情况下，我们将在七个工作日内回复。
    </div>
</template>

<script>
import jsbridg from "../../utils/jsbridg"
export default {
    name: 'credential',
    mounted () {
        document.getElementsByTagName('title')[0].innerHTML = '隐私协议';
        jsbridg.setTitle('隐私协议')
    }
}

</script>
<style lang="less">
.harmonyPrivacy{
    padding:0 10px;
    line-height: 20px;
    h3,h4,h5{
        color:#171717;
        font-weight: bold;
        margin: 5px;
    }
    b{
        color:#171717;
        font-weight: bold;
    }
    h3{
        font-size: 20px;
    }
    h4{
        font-size: 17px;
    }
    h5{
        font-size: 15px;
    }
    .um{
        font-weight: 700;
        color: #000;
    }
    em{
        font-weight: bold;
        color:#171717;
    }
    i{
        &.special{
            display: none;
        }
    }
    .lasttip{
        color:#bca272;
        text-align: center;
    }
}
</style>
